import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '$store/rootReducer';
import {
  AdventCalendarState,
  GetAdventCalendarAction,
  SetAdventCalendarAction,
  CreateAdventCalendarAction,
  CreateAdventBundleAction,
  UpdateAdventBundleAction,
  UpdateCalendarDaysAction,
  LoadBundleForEditingAction,
} from './interface';

const initialState: AdventCalendarState = {
  calendars: {},
  loading: {},
  editingBundle: null,
  loadingBundleId: null,
};

export const { actions, reducer } = createSlice({
  name: 'adventCalendar',
  initialState,
  reducers: {
    getAdventCalendar(_, action: GetAdventCalendarAction) {},
    createAdventCalendar(_, action: CreateAdventCalendarAction) {},
    createAdventBundle(_, action: CreateAdventBundleAction) {},
    updateAdventBundle(_, action: UpdateAdventBundleAction) {},
    updateCalendarDays(_, action: UpdateCalendarDaysAction) {},
    loadBundleForEditing(_, action: LoadBundleForEditingAction) {},
    setAdventCalendar: (state, action: SetAdventCalendarAction) => {
      const payload = action.payload;

      if (!payload) {
        return;
      }

      if ('calendar' in payload && payload.calendar === null) {
        delete state.calendars[payload.userId];
      } else if ('userId' in payload) {
        state.calendars[payload.userId] = payload as any;
      }
    },
    setLoading: (state, action: { payload: { userId: number; loading: boolean } }) => {
      state.loading[action.payload.userId] = action.payload.loading;
    },
    setEditingBundle: (state, action: { payload: any }) => {
      state.editingBundle = action.payload;
      state.loadingBundleId = null;
    },
    clearEditingBundle: (state) => {
      state.editingBundle = null;
      state.loadingBundleId = null;
    },
    setLoadingBundleId: (state, action: { payload: number | null }) => {
      state.loadingBundleId = action.payload;
    },
  },
});

export { reducer as adventCalendarReducer, actions as adventCalendarActions };
export type { AdventCalendarDay } from './interface';

export const adventCalendarStateSelector = (state: RootState) => state.adventCalendar;

export const adventCalendarSelector = createSelector(
  [adventCalendarStateSelector, (_, userId?: number) => userId],
  (state, userId) => (userId ? state.calendars[userId] || null : null),
);

export const adventCalendarLoadingSelector = createSelector(
  [adventCalendarStateSelector, (_, userId?: number) => userId],
  (state, userId) => (userId ? state.loading[userId] || false : false),
);

export const editingBundleSelector = (state: RootState) =>
  state.adventCalendar.editingBundle;

export const loadingBundleIdSelector = (state: RootState) =>
  state.adventCalendar.loadingBundleId;
